module.exports = __webpack_public_path__ + "img/pos-bg.c1e7012.jpg";